export default "__VITE_ASSET__D1racJgV__"